import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './index.css';

const container = document.getElementById('root')!;

const tree = (
  <StrictMode>
    <App />
  </StrictMode>
);

/**
 * Hydration waits for the browser to be idle.
 *
 * The production build ships the whole page as markup, and every call to action
 * on it is a plain `<a href>` — `tel:`, a maps link, an in-page anchor — so the
 * page is readable and usable before a line of React runs. Hydrating during the
 * first paint put a ~585ms task in front of the Largest Contentful Paint and
 * bought nothing, because the only things React owns here are motion and the
 * canvas, and both already wait for idle themselves.
 */
function start() {
  if (container.hasChildNodes()) {
    hydrateRoot(container, tree);
  } else {
    createRoot(container).render(tree);
  }
}

if (!container.hasChildNodes() || typeof window.requestIdleCallback !== 'function') {
  start();
} else {
  let started = false;

  const begin = () => {
    if (started) {
      return;
    }

    started = true;
    window.removeEventListener('pointerdown', begin);
    window.removeEventListener('keydown', begin);
    window.removeEventListener('scroll', begin);
    start();
  };

  window.requestIdleCallback(begin, { timeout: 900 });
  window.addEventListener('pointerdown', begin, { once: true, passive: true });
  window.addEventListener('keydown', begin, { once: true });
  window.addEventListener('scroll', begin, { once: true, passive: true });
}
